import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "./Dashboard.css";
import logo from "../assets/logo.png";
import chip from "../assets/silver_qr.png";
import sendarrow from "../assets/send.png";
import receivearrow from "../assets/recieve-arrow.png";
import buyarrow from "../assets/buy.png";
import historyarrow from "../assets/history.png";
import tradearrow from "../assets/trade.png";
import Card from "../assets/cards-dashboard/Card";
import { getCryptoIcon } from "../config/cryptoIcons";
import spinWheelIcon from "../assets/spinandwin.png";
import { logout, clearUserData } from "../utils/authUtils";
import {
  LineChart, Line, AreaChart, Area, ResponsiveContainer,
  XAxis, YAxis, Tooltip, CartesianGrid
} from 'recharts';

// Retry with exponential backoff
const fetchWithBackoff = async (fetchFn, retries = 3, delay = 1000) => {
  for (let i = 0; i < retries; i++) {
    try {
      return await fetchFn();
    } catch (err) {
      if (err?.response?.status === 429 && i < retries - 1) {
        await new Promise(res => setTimeout(res, delay * Math.pow(2, i)));
      } else {
        throw err;
      }
    }
  }
};

// Static fallback data
const STATIC_ASSETS = [
  {
    name: "BTC",
    symbol: "btc",
    sub: "Bitcoin",
    price: 85966.43,
    balance: 0.0665,
    change: -0.17,
    balanceValue: 5713.45
  },
  {
    name: "USDT",
    symbol: "usdtBnb",
    sub: "Tether BEP-20",
    price: 1.0,
    balance: 8766.42,
    change: 0.0,
    balanceValue: 8766.42
  }
];

// Generate mock historical data for charts
const generateHistoricalData = (basePrice, change, points = 24) => {
  const data = [];
  const now = Date.now();
  const volatility = Math.abs(change) / 100 || 0.02;
  
  for (let i = points; i >= 0; i--) {
    const timestamp = now - i * 3600000;
    const randomFactor = 1 + (Math.random() - 0.5) * volatility;
    const trendFactor = 1 + (change / 100) * (i / points);
    const price = basePrice * randomFactor * trendFactor;
    
    data.push({
      time: new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      price: price,
      timestamp
    });
  }
  return data;
};

/* ================= FLOATING SUPPORT BUTTONS COMPONENT ================= */
const FloatingSupportButtons = () => {
  const handleTelegramClick = () => {
    window.open("https://t.me/Instacoinxpayteam", "_blank");
  };

  const handleWhatsAppClick = () => {
    window.open("https://wa.me/+16417762676?text=Hello%20Instacoinxpay%2C%20I%20need%20assistance%20with%20my%20dashboard%20on%20InstaCoinXPay.", "_blank");
  };

  return (
    <div className="dashboard-floating-support-buttons">
      <button className="dashboard-float-btn dashboard-telegram-float-btn" onClick={handleTelegramClick} aria-label="Telegram Support">
        <svg className="dashboard-float-icon" viewBox="0 0 24 24" width="28" height="28" fill="white">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.66-.35-1.02.22-1.61.15-.15 2.71-2.48 2.76-2.69.01-.03.01-.14-.06-.2-.07-.06-.18-.04-.26-.02-.11.02-1.86 1.18-5.26 3.48-.5.34-.95.51-1.35.5-.44-.01-1.3-.25-1.93-.46-.78-.26-1.4-.4-1.35-.84.03-.23.35-.47.96-.72 3.76-1.64 6.27-2.72 7.53-3.23 3.58-1.46 4.33-1.71 4.81-1.72.11 0 .35.02.51.16.13.11.17.26.19.4.01.06.02.19-.01.33z"/>
        </svg>
        <span className="dashboard-float-label">Telegram Support</span>
      </button>
      
      <button className="dashboard-float-btn dashboard-whatsapp-float-btn" onClick={handleWhatsAppClick} aria-label="WhatsApp Support">
        <svg className="dashboard-float-icon" viewBox="0 0 24 24" width="28" height="28" fill="white">
          <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-5.46-4.45-9.91-9.91-9.91zm0 18.22c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.12.82.83-3.04-.2-.31c-.84-1.34-1.29-2.88-1.29-4.46 0-4.62 3.76-8.38 8.38-8.38 4.62 0 8.38 3.76 8.38 8.38 0 4.62-3.76 8.38-8.38 8.38zm4.59-6.27c-.25-.13-1.5-.74-1.73-.83-.23-.08-.4-.13-.57.13-.17.26-.65.83-.8 1-.14.17-.29.19-.54.06-.25-.13-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.39-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.44.12-.15.17-.25.25-.42.08-.17.04-.31-.02-.44-.06-.13-.57-1.37-.78-1.88-.21-.5-.41-.44-.57-.45-.15-.01-.32-.01-.49-.01-.17 0-.44.06-.67.31-.23.25-.88.86-.88 2.11 0 1.24.91 2.45 1.04 2.61.13.17 1.79 2.73 4.33 3.83.61.26 1.08.42 1.45.54.61.19 1.16.16 1.6.1.49-.07 1.5-.61 1.71-1.2.21-.59.21-1.09.15-1.2-.07-.1-.23-.17-.48-.3z"/>
        </svg>
        <span className="dashboard-float-label">WhatsApp Support</span>
      </button>
    </div>
  );
};

/* ================= SPIN WHEEL NAVIGATION BUTTON ================= */
const SpinWheelNavButton = ({ 
  position = "right",
  bottom = "180px",
  right = "30px",
  left = "auto",
  size = "60px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const navigate = useNavigate();
  
  const positionStyles = position === "left" 
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    background: 'radial-gradient(circle at 30% 30%, #f7931a, #c8930a)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4)',
    zIndex: 9998,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    border: '3px solid rgba(255, 215, 0, 0.6)',
    overflow: 'hidden',
    padding: '0px',
    ...positionStyles,
    ...style
  };

  React.useEffect(() => {
    if (!document.querySelector('#dashboard-spin-wheel-keyframes')) {
      const styleSheet = document.createElement("style");
      styleSheet.id = 'dashboard-spin-wheel-keyframes';
      styleSheet.textContent = `
        @keyframes dashboardSpinWheelPulse {
          0% { box-shadow: 0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4), 0 0 0 0 rgba(247, 147, 26, 0.7); }
          70% { box-shadow: 0 8px 35px rgba(247, 147, 26, 0.7), 0 0 30px rgba(200, 147, 10, 0.6), 0 0 0 15px rgba(247, 147, 26, 0); }
          100% { box-shadow: 0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4), 0 0 0 0 rgba(247, 147, 26, 0); }
        }
        @keyframes dashboardSpinWheelGlow {
          0% { filter: drop-shadow(0 0 5px #f7931a); }
          50% { filter: drop-shadow(0 0 15px #c8930a); }
          100% { filter: drop-shadow(0 0 5px #f7931a); }
        }
        @keyframes dashboardSpinWheelRotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .dashboard-spin-wheel-nav-float {
          animation: ${pulseEffect ? 'dashboardSpinWheelPulse 2s infinite, dashboardSpinWheelGlow 3s infinite' : 'none'};
        }
        .dashboard-spin-wheel-nav-float:hover {
          transform: scale(1.15) rotate(10deg) !important;
          background: radial-gradient(circle at 30% 30%, #ffd700, #f7931a) !important;
          box-shadow: 0 10px 40px rgba(247, 147, 26, 0.8), 0 0 35px rgba(255, 215, 0, 0.7) !important;
        }
        .dashboard-spin-wheel-nav-float:hover .dashboard-wheel-icon-image {
          transform: scale(1.2) rotate(15deg) !important;
        }
        .dashboard-wheel-icon-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          transition: transform 0.3s ease;
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, [pulseEffect]);

  const handleClick = () => navigate('/spinwheel');

  return (
    <button
      onClick={handleClick}
      className={`dashboard-spin-wheel-nav-float ${className}`}
      style={combinedStyles}
      aria-label="Spin the Fortune Wheel"
      title="🎡 Spin & Win Rewards!"
    >
      <img 
        src={spinWheelIcon} 
        alt="Fortune Wheel"
        className="dashboard-wheel-icon-image"
        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%', transition: 'transform 0.3s ease', transform: 'scale(1.1)' }}
      />
      <div style={{
        position: 'absolute', inset: '-6px', borderRadius: '50%',
        border: '3px solid rgba(255, 215, 0, 0.5)',
        borderTopColor: '#f7931a', borderRightColor: '#ffd700',
        borderBottomColor: '#f7931a', borderLeftColor: '#ffd700',
        opacity: 0.9, animation: 'dashboardSpinWheelRotate 4s linear infinite',
        pointerEvents: 'none', boxShadow: '0 0 15px rgba(247, 147, 26, 0.6)'
      }} />
      <div style={{
        position: 'absolute', inset: '2px', borderRadius: '50%',
        border: '1px solid rgba(255, 255, 255, 0.3)', opacity: 0.5, pointerEvents: 'none'
      }} />
    </button>
  );
};

// Custom Tooltip for Chart
const CustomTooltipDashboard = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="dashboard-custom-tooltip">
        <p className="dashboard-custom-tooltip-label">{label}</p>
        <p className="dashboard-custom-tooltip-value">
          ${payload[0].value.toFixed(2)}
        </p>
      </div>
    );
  }
  return null;
};

const getDisplayName = (symbol = "") => {
  const s = symbol.toLowerCase();
  if (s === "usdtbnb") return "USDT";
  if (s === "usdttron") return "USDT";
  if (s.startsWith("usdt")) return "USDT";
  return s.toUpperCase();
};

const mapCardType = (cardType = "") => {
  const t = cardType.toLowerCase();
  if (t.includes("merchant")) return "merchant";
  if (t.includes("classic")) return "classic";
  if (t.includes("prime")) return "prime";
  if (t.includes("platinum")) return "platinum";
  if (t.includes("elite")) return "elite";
  return "classic";
};

const mapDashboardSymbolToTrading = (symbol = "") => {
  const s = symbol.toLowerCase();
  if (s === "btc") return "BTC";
  if (s === "eth") return "ETH";
  if (s === "bnb") return "BNB";
  if (s === "sol") return "SOL";
  if (s === "xrp") return "XRP";
  if (s === "doge") return "DOGE";
  if (s === "ltc") return "LTC";
  if (s === "trx") return "TRX";
  if (s === "usdttron" || s === "usdttrc20" || (s.startsWith("usdt") && s.includes("tron"))) return "USDT_TRC20";
  if (s === "usdtbnb" || s === "usdtbep20" || s.startsWith("usdt")) return "USDT_BEP20";
  return s.toUpperCase();
};

const ADMIN_EMAIL = "bitabox860@gmail.com";

const Dashboard = () => {
  const navigate = useNavigate();

  const initializingRef = useRef(false);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [tickerData, setTickerData] = useState([]);
  const [portfolioSummary, setPortfolioSummary] = useState(null);
  const [walletBalance, setWalletBalance] = useState(null);
  const [loading, setLoading] = useState({
    dashboard: false,
    ticker: false,
    portfolio: false,
    balance: false,
  });
  const [userProfile, setUserProfile] = useState(null);
  const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail"));
  const [totalBalance, setTotalBalance] = useState("$0");
  const [userAssets, setUserAssets] = useState([]);
  const [dataSource, setDataSource] = useState("live");
  const [lastUpdate, setLastUpdate] = useState("");
  const [chartData, setChartData] = useState({});
  const [expandedChart, setExpandedChart] = useState(null);
  const [priceHistory, setPriceHistory] = useState({});
  
  const [cardData, setCardData] = useState(() => {
    const savedCard = localStorage.getItem("userCardData");
    return savedCard ? JSON.parse(savedCard) : null;
  });

  const isAdmin = userEmail === ADMIN_EMAIL;

  const handleLogout = async () => {
    await logout(navigate);
  };

  const handleSidebarLogout = async () => {
    closeSidebar();
    await logout(navigate);
  };

  // Crisp Chat Integration
  useEffect(() => {
    window.$crisp = window.$crisp || [];
    window.CRISP_WEBSITE_ID = "b5635951-f13a-4b92-95d7-c1e3666f3abf";
    window.$crisp.push(["do", "chat:show"]);

    if (!document.querySelector('script[src="https://client.crisp.chat/l.js"]')) {
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.async = true;
      document.head.appendChild(script);
    }

    return () => {
      if (window.$crisp) window.$crisp.push(["do", "chat:hide"]);
    };
  }, []);

  useEffect(() => {
    if (userEmail && window.$crisp) {
      window.$crisp.push(["set", "user:email", userEmail]);
      if (userProfile?.fullName) {
        window.$crisp.push(["set", "user:nickname", userProfile.fullName]);
      }
    }
  }, [userEmail, userProfile]);

  const fetchDebitCard = async () => {
    try {
      if (!userEmail) return;
      const res = await fetchWithBackoff(() =>
        axios.get(
          `https://backend-safepal.onrender.com/api/debit-card/by-email/${userEmail}`,
          { withCredentials: true }
        )
      );
      if (res.data.success && res.data.data) {
        setCardData(res.data.data);
        localStorage.setItem("userCardData", JSON.stringify(res.data.data));
      }
    } catch (err) {
      if (err.response?.status === 404) {
        if (!localStorage.getItem("userCardData")) setCardData(null);
      } else {
        console.warn("Debit card fetch failed, using cached data");
      }
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD',
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(amount);
  };

  const fetchUserProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");
      if (!token || !userId) return;

      const res = await fetchWithBackoff(() =>
        axios.get(
          `https://backend-safepal.onrender.com/api/auth/users/${userId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
      );
      if (res.data.success) {
        setUserProfile(res.data.data);
        localStorage.setItem("userProfile", JSON.stringify(res.data.data));
      }
    } catch (error) {
      console.warn("Error fetching user profile:", error.message);
    }
  };

  const formatPercentage = (value) => {
    const sign = value >= 0 ? "+" : "";
    return `${sign}${value.toFixed(2)}%`;
  };

  // Fetch Live Price History
  const fetchPriceHistory = async (symbol) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return null;

      const response = await axios.get(
        `https://backend-safepal.onrender.com/api/crypto/history/${symbol}?days=1`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success && response.data.data) {
        let { prices } = response.data.data;

        if (prices && !Array.isArray(prices)) {
          prices = Object.values(prices);
        }

        if (!Array.isArray(prices) || prices.length === 0) {
          console.warn("Invalid prices data:", response.data.data);
          return null;
        }

        return prices.map((entry) => {
          const [timestamp, price] = Array.isArray(entry) ? entry : [entry.timestamp, entry.price];
          return {
            time: new Date(timestamp).toLocaleTimeString([], { 
              hour: '2-digit', 
              minute: '2-digit' 
            }),
            price,
            timestamp
          };
        });
      }
      return null;
    } catch (error) {
      console.log(`Error fetching history for ${symbol}:`, error.message);
      return null;
    }
  };

  // ✅ FIXED: Persist real dashboard balances with protection against trade overwrite
  const persistBalancesForTrading = (assets, totalUsdValue) => {
    try {
      const existingBalance = localStorage.getItem('dashboard_trading_usd_balance');
      const lastTradeSync = localStorage.getItem('dashboard_trading_last_sync');

      // 🧠 Prevent overwrite if trade happened recently
      if (existingBalance && lastTradeSync) {
        const lastSyncTime = new Date(lastTradeSync).getTime();
        const now = new Date().getTime();
        const secondsAgo = (now - lastSyncTime) / 1000;

        if (secondsAgo < 120) {
          console.log('⛔ Skipping dashboard overwrite (recent trade)');
          return;
        }
      }

      // ✅ Normal sync
      const tradingPortfolio = {};
      assets.forEach(asset => {
        const tradingKey = mapDashboardSymbolToTrading(asset.symbol);
        const coinBalance = asset.balance ?? 0;
        if (coinBalance > 0) {
          tradingPortfolio[tradingKey] = coinBalance;
        }
      });

      localStorage.setItem('dashboard_trading_portfolio', JSON.stringify(tradingPortfolio));
      localStorage.setItem('dashboard_trading_usd_balance', totalUsdValue.toString());
      localStorage.setItem('dashboard_trading_last_sync', new Date().toISOString());

      console.log("✅ Dashboard → Trading sync complete");
      console.log("💰 Balance synced:", totalUsdValue);

    } catch (err) {
      console.error("Sync error:", err);
    }
  };

  const fetchDashboardData = async () => {
    try {
      setLoading(prev => ({ ...prev, dashboard: true }));
      const token = localStorage.getItem("token");
      if (!token) return applyStaticData();

      const response = await fetchWithBackoff(() =>
        axios.get("https://backend-safepal.onrender.com/api/crypto/dashboard", {
          headers: { Authorization: `Bearer ${token}` }
        })
      );
      console.log('🔍 RAW DASHBOARD DATA:', JSON.stringify(response.data, null, 2));
      
      if (!response.data.success) return applyStaticData();

      let assets = [];
      let totalUsd = 0;
      
      if (response.data.data && response.data.data.assets) {
        assets = response.data.data.assets || [];
        totalUsd = response.data.data.totalPortfolioValue || 
          assets.reduce((sum, a) => sum + (a.balanceValue || 0), 0);
      } else if (response.data.data && Array.isArray(response.data.data)) {
        assets = response.data.data;
        totalUsd = assets.reduce((sum, a) => sum + (a.balanceValue || 0), 0);
      } else {
        assets = response.data.data?.assets || response.data.data || [];
        totalUsd = response.data.data?.totalPortfolioValue || 
          assets.reduce((sum, a) => sum + (a.balanceValue || 0), 0);
      }

      const histories = [];
      for (const asset of assets) {
        const history = await fetchPriceHistory(asset.symbol);
        histories.push({ symbol: asset.symbol, history });
        await new Promise(res => setTimeout(res, 400));
      }

      const historyMap = {};
      histories.forEach(h => {
        if (h.history) {
          historyMap[h.symbol] = h.history;
        }
      });
      setPriceHistory(historyMap);

      const mappedAssets = assets.map(asset => ({
        icon: getCryptoIcon(
          asset.symbol === 'USDTBNB' ? 'usdtBnb' :
          asset.symbol === 'USDTTRON' ? 'usdtTron' :
          asset.symbol?.toLowerCase() || asset.coin?.toLowerCase()
        ),
        name: getDisplayName(asset.symbol || asset.coin),
        symbol: (asset.symbol || asset.coin)?.toLowerCase(),
        sub: asset.name || asset.coin,
        price: formatCurrency(asset.currentPrice || 0),
        rawPrice: asset.currentPrice || 0,
        rawChange: asset.priceChangePercentage24h || 0,
        change: formatPercentage(asset.priceChangePercentage24h || 0),
        balance: asset.balance || 0,
        balanceText: formatCurrency((asset.balance || 0) * (asset.currentPrice || 0)),
        usdValue: asset.balanceValue || 0,
        chartData: historyMap[asset.symbol || asset.coin] || generateHistoricalData(
          asset.currentPrice || 0,
          asset.priceChangePercentage24h || 0
        ),
        originalAsset: asset
      }));

      setUserAssets(mappedAssets);

      setTotalBalance(formatCurrency(totalUsd));
      setLastUpdate(new Date().toLocaleTimeString());
      setDataSource("live");

      // ✅ Sync real balances to localStorage for TradingPanel
      persistBalancesForTrading(assets, totalUsd);

      localStorage.removeItem('last_trade_timestamp');

    } catch (err) {
      console.error("Error fetching dashboard:", err);
      applyStaticData();
    } finally {
      setLoading(prev => ({ ...prev, dashboard: false }));
    }
  };

  const applyStaticData = () => {
    setDataSource("static");
    setLastUpdate(new Date().toLocaleTimeString());

    const assetsWithIcons = STATIC_ASSETS.map(asset => ({
      ...asset,
      icon: getCryptoIcon(asset.symbol),
      price: formatCurrency(asset.price),
      rawPrice: asset.price,
      balanceText: formatCurrency(asset.balanceValue),
      change: formatPercentage(asset.change),
      rawChange: asset.change,
      chartData: generateHistoricalData(asset.price, asset.change)
    }));

    setUserAssets(assetsWithIcons);

    const total = STATIC_ASSETS.reduce((sum, asset) => sum + asset.balanceValue, 0);
    setTotalBalance(formatCurrency(total));

    // Sync static portfolio for TradingPanel
    const staticPortfolio = {};
    STATIC_ASSETS.forEach(asset => {
      const tradingKey = mapDashboardSymbolToTrading(asset.symbol);
      staticPortfolio[tradingKey] = asset.balance;
    });
    localStorage.setItem('dashboard_trading_portfolio', JSON.stringify(staticPortfolio));
    localStorage.setItem('dashboard_trading_usd_balance', total.toString());
  };

  const fetchTickerData = async () => {
    try {
      setLoading(prev => ({ ...prev, ticker: true }));
      const token = localStorage.getItem("token");

      const makeStaticTicker = () => STATIC_ASSETS.map(asset => ({
        symbol: asset.name, name: asset.sub, price: asset.price,
        change: 0, changePercent: asset.change, volume: 0, marketCap: 0
      }));

      if (!token) {
        setTickerData(makeStaticTicker());
        return;
      }

      const response = await fetchWithBackoff(() =>
        axios.get("https://backend-safepal.onrender.com/api/crypto/ticker", {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          timeout: 8000
        })
      );

      if (response.data.success && response.data.data) {
        setTickerData(response.data.data);
        localStorage.setItem('cryptoPrices', JSON.stringify(response.data.data));
      } else {
        setTickerData(makeStaticTicker());
      }
    } catch (error) {
      console.warn("Error fetching ticker:", error.message);
      setTickerData(STATIC_ASSETS.map(asset => ({
        symbol: asset.name, name: asset.sub, price: asset.price,
        change: 0, changePercent: asset.change, volume: 0, marketCap: 0
      })));
    } finally {
      setLoading(prev => ({ ...prev, ticker: false }));
    }
  };

  const fetchWalletBalance = async () => {
    try {
      setLoading(prev => ({ ...prev, balance: true }));
      const token = localStorage.getItem("token");
      if (!token) return;

      const response = await fetchWithBackoff(() =>
        axios.get("https://backend-safepal.onrender.com/api/transfer/balance", {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
        })
      );

      if (response.data.success) {
        setWalletBalance(response.data.data);
        localStorage.setItem('walletBalance', JSON.stringify(response.data.data));
      }
    } catch (error) {
      console.warn("Error fetching wallet balance:", error.message);
    } finally {
      setLoading(prev => ({ ...prev, balance: false }));
    }
  };

  useEffect(() => {
    const savedProfile = localStorage.getItem("userProfile");
    if (savedProfile) setUserProfile(JSON.parse(savedProfile));
  }, []);

  const refreshAllData = () => {
    fetchDashboardData();
    fetchTickerData();
    fetchWalletBalance();
  };

  useEffect(() => {
    if (initializingRef.current) return;
    initializingRef.current = true;

    const initDashboard = async () => {
      try {
        const lastTradeTime = localStorage.getItem('last_trade_timestamp');
        if (lastTradeTime) {
          const secondsSince = (Date.now() - new Date(lastTradeTime).getTime()) / 1000;
          if (secondsSince < 300) {
            localStorage.removeItem('dashboard_trading_last_sync');
            localStorage.removeItem('dashboard_trading_usd_balance');
            localStorage.removeItem('dashboard_trading_portfolio');
            console.log('🔄 Trade detected — forcing fresh dashboard fetch');
          }
        }

        await fetchUserProfile();
        await new Promise(res => setTimeout(res, 600));
        await fetchDebitCard();
        await new Promise(res => setTimeout(res, 600));
        await fetchWalletBalance();
        await new Promise(res => setTimeout(res, 600));
        await fetchTickerData();
        await new Promise(res => setTimeout(res, 800));
        await fetchDashboardData();
      } catch (err) {
        console.error("Init error:", err);
      }
    };

    initDashboard();

    const handleTradeCompleted = async () => {
      console.log('🔄 Trade completed event received — refreshing dashboard balances');
      localStorage.removeItem('dashboard_trading_last_sync');
      localStorage.removeItem('dashboard_trading_usd_balance');
      localStorage.removeItem('dashboard_trading_portfolio');
      await new Promise(resolve => setTimeout(resolve, 500));
      await fetchDashboardData();
      await fetchTickerData();
    };

    window.addEventListener('tradeCompleted', handleTradeCompleted);

    const intervalId = setInterval(() => {
      fetchDashboardData();
      setTimeout(() => fetchTickerData(), 8000);
    }, 180000);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('tradeCompleted', handleTradeCompleted);
    };
  }, [userEmail]);
  
  const openWallet = (asset) => {
    const assetToPass = {
      ...asset,
      iconPath: asset.icon,
      originalAsset: asset.originalAsset || {
        key: asset.symbol.toLowerCase(),
        balance: asset.originalAsset?.balance || asset.balance || 0,
        balanceValue: asset.originalAsset?.balanceValue || asset.usdValue || 0,
        currentPrice: asset.originalAsset?.currentPrice || asset.rawPrice,
        symbol: asset.symbol,
        name: asset.sub
      }
    };
    navigate("/bitcoinwallet", { state: assetToPass });
  };

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  const handleReceive = () => navigate("/balreceive");
  const handleSend = () => {
    if (userAssets && userAssets.length > 0) {
      navigate("/sendbtc", {
        state: {
          ...userAssets[0],
          name: userAssets[0].name,
          sub: userAssets[0].sub,
          balance: userAssets[0].balance,
          icon: userAssets[0].icon
        }
      });
    } else {
      navigate("/sendbtc");
    }
  };
  const handleBuy = () => navigate("/walletoption");
  const handleTrade = () => navigate("/tradingpanel");
  const handleHistory = () => navigate("/history");

  const toggleChart = (index) => {
    if (expandedChart === index) {
      setExpandedChart(null);
    } else {
      setExpandedChart(index);
    }
  };

  const displayAssets = userAssets.length > 0 ? userAssets : STATIC_ASSETS.map(asset => ({
    ...asset,
    price: formatCurrency(asset.price),
    rawPrice: asset.price,
    balanceText: formatCurrency(asset.balanceValue),
    change: formatPercentage(asset.change),
    rawChange: asset.change,
    chartData: generateHistoricalData(asset.price, asset.change)
  }));

  const getCardStatus = () => {
    if (cardData?.status) return cardData.status;
    const savedCard = localStorage.getItem("userCardData");
    if (savedCard) return JSON.parse(savedCard).status;
    return "INACTIVE";
  };

  return (
    <>
      <div className={`dashboard-container ${sidebarOpen ? 'dashboard-blur-background' : ''}`}>
        <header className="dashboard-header">
          <img src={logo} alt="logo" />
          <div className="dashboard-menu-icon" onClick={toggleSidebar}>☰</div>
        </header>

        <div className="dashboard-top-section">
          <div className="dashboard-balance-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="dashboard-connect-link">
                <Link className="dashboard-connect-link-text" to="/walletoption">Connect Wallet</Link>
              </span>
              <button 
                onClick={refreshAllData}
                style={{
                  background: '#4caf50',
                  border: 'none',
                  borderRadius: '5px',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '11px',
                  padding: '5px 10px'
                }}
              >
                ⟳ Refresh
              </button>
            </div>
            <p>Your Balance</p>
            <h2>{totalBalance}</h2>

            <div style={{
              fontSize: '11px', color: '#888', marginBottom: '15px',
              display: 'flex', justifyContent: 'space-between'
            }}>
              <span>Last updated: {lastUpdate || '--:--'}</span>
              {dataSource === 'static' && (
                <span style={{ color: '#ff9800', fontSize: '10px' }}>Static Data</span>
              )}
            </div>

            <div className="dashboard-actions">
              <div onClick={handleReceive}>
                <div className="dashboard-action-box">
                  <img src={receivearrow} alt="Receive" style={{ width: '48px', height: '40px' }} />
                </div>
                <span>Receive</span>
              </div>
              <div onClick={handleSend}>
                <div className="dashboard-action-box">
                  <img src={sendarrow} alt="Send" style={{ width: '48px', height: '48px' }} />
                </div>
                <span>Send</span>
              </div>
              <div onClick={handleBuy}>
                <div className="dashboard-action-box">
                  <img src={buyarrow} alt="Buy" style={{ width: '48px', height: '48px' }} />
                </div>
                <span>Buy</span>
              </div>
              <div onClick={handleTrade}>
                <div className="dashboard-action-box">
                  <img src={tradearrow} alt="Trade" style={{ width: '48px', height: '48px' }} />
                </div>
                <span>Trade</span>
              </div>
              <div onClick={handleHistory}>
                <div className="dashboard-action-box">
                  <img src={historyarrow} alt="History" style={{ width: '48px', height: '48px' }} />
                </div>
                <span>History</span>
              </div>
            </div>
          </div>

          <div className="dashboard-visa-container">
            <Card
              type={mapCardType(cardData?.cardType)}
              number={cardData?.cardNumber || "XXXX XXXX XXXX XXXX"}
              holder={cardData?.fullName || userProfile?.fullName || "CARD HOLDER"}
              expiry={cardData?.expiry || "XX/XX"}
              cvv={cardData?.cvv || "XXX"}
              status={getCardStatus()}
            />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <h3 className="dashboard-assets-title">Assets</h3>
          {loading.dashboard && (
            <small style={{ color: '#ff9800', fontSize: '11px' }}>Loading...</small>
          )}
        </div>

        <div className="dashboard-assets">
          {displayAssets.map((item, i) => (
            <div
              className={`dashboard-asset-card ${expandedChart === i ? 'dashboard-asset-card-expanded' : ''}`}
              key={i}
              style={{ cursor: "pointer" }}
            >
              <div className="dashboard-asset-main-content" onClick={() => openWallet(item)}>
                <img src={item.icon} alt={item.name} className="dashboard-asset-icon" />
                
                <div className="dashboard-asset-info">
                  <strong>{item.name}</strong>
                  <span>{item.sub}</span>
                </div>
                
                <div className={`dashboard-asset-change ${item.rawChange >= 0 ? "dashboard-green" : "dashboard-red"}`}>
                  <span>{item.change}</span>
                  <span style={{ fontSize: '10px', opacity: 0.85 }}>24hr</span>
                </div>
                
                <div className="dashboard-asset-price">
                  <strong>{item.price}</strong>
                </div>
                
                <div className="dashboard-asset-chart-preview" onClick={(e) => { e.stopPropagation(); toggleChart(i); }}>
                  {item.chartData && (
                    <ResponsiveContainer width="100%" height={40}>
                      <AreaChart data={item.chartData}>
                        <defs>
                          <linearGradient id={`dashboard-gradient-${i}`} x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={item.rawChange >= 0 ? "#4caf50" : "#f44336"} stopOpacity={0.3}/>
                            <stop offset="95%" stopColor={item.rawChange >= 0 ? "#4caf50" : "#f44336"} stopOpacity={0}/>
                          </linearGradient>
                        </defs>
                        <Area
                          type="monotone"
                          dataKey="price"
                          stroke={item.rawChange >= 0 ? "#4caf50" : "#f44336"}
                          strokeWidth={1.5}
                          fill={`url(#dashboard-gradient-${i})`}
                          dot={false}
                        />
                      </AreaChart>
                    </ResponsiveContainer>
                  )}
                </div>
                
                {/* ✅ FIXED BALANCE - Always visible, larger, with background highlight */}
                <div className="dashboard-asset-balance">
                  {item.balanceText}
                </div>
              </div>

              {expandedChart === i && (
                <div className="dashboard-asset-expanded-chart" onClick={(e) => e.stopPropagation()}>
                  <div className="dashboard-expanded-chart-container">
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart data={item.chartData}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#333" />
                        <XAxis
                          dataKey="time"
                          stroke="#888"
                          tick={{ fontSize: 10, fill: '#888' }}
                          interval="preserveStartEnd"
                        />
                        <YAxis
                          stroke="#888"
                          tick={{ fontSize: 10, fill: '#888' }}
                          domain={['auto', 'auto']}
                          tickFormatter={(value) => `$${value.toFixed(0)}`}
                        />
                        <Tooltip content={<CustomTooltipDashboard />} />
                        <Line
                          type="monotone"
                          dataKey="price"
                          stroke={item.rawChange >= 0 ? "#4caf50" : "#f44336"}
                          strokeWidth={2}
                          dot={false}
                          activeDot={{ r: 4, fill: "#b57cff" }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="dashboard-expanded-chart-stats">
                    <span>24h Low: ${Math.min(...item.chartData.map(d => d.price)).toFixed(2)}</span>
                    <span>24h High: ${Math.max(...item.chartData.map(d => d.price)).toFixed(2)}</span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div
        className={`dashboard-sidebar-overlay ${sidebarOpen ? "dashboard-sidebar-overlay-active" : ""}`}
        onClick={closeSidebar}
      ></div>

      <div className={`dashboard-sidebar ${sidebarOpen ? "dashboard-sidebar-active" : ""}`}>
        <div className="dashboard-sidebar-header">
          <img src={logo} alt="logo" className="dashboard-sidebar-logo" />
          <Link to="/userprofile" className="dashboard-user-profile-btn" onClick={closeSidebar}>
            User Profile
          </Link>
          <button className="dashboard-close-sidebar" onClick={closeSidebar}>×</button>
        </div>

        <div className="dashboard-sidebar-menu">
          {isAdmin && (
            <div className="dashboard-sidebar-item">
              <Link to="/admin-panel" onClick={closeSidebar}>Admin Panel</Link>
            </div>
          )}
          <div className="dashboard-sidebar-item">
            <Link to="/dashboard" onClick={closeSidebar}>Dashboard</Link>
          </div>
          <div className="dashboard-sidebar-item">
            <Link to="/withdrawal" onClick={closeSidebar}>Withdrawal</Link>
          </div>
          <div className="dashboard-sidebar-item">
            <Link to="/creditcards" onClick={closeSidebar}>Activate Debit Card</Link>
          </div>
          <div className="dashboard-sidebar-item">
            <Link to="/walletoption" onClick={closeSidebar}>Connect Trust Wallet</Link>
          </div>
          <div className="dashboard-sidebar-item">
            <Link to="/support" onClick={closeSidebar}>Support</Link>
          </div>
          <div className="dashboard-sidebar-item">
            <Link to="/report" onClick={closeSidebar}>Report</Link>
          </div>
          <div className="dashboard-sidebar-item">
            <Link to="/referearn" onClick={closeSidebar}>Referral Link</Link>
          </div>
          <div className="dashboard-sidebar-item">
            <Link to="/spinwheel" onClick={closeSidebar}>Spin Wheel</Link>
          </div>
          <div className="dashboard-sidebar-item">
            <Link to="/tradingpanel" onClick={closeSidebar}>Trade</Link>
          </div>
          <div className="dashboard-sidebar-item dashboard-logout-item">
            <button onClick={handleSidebarLogout} className="dashboard-logout-button">
              Logout
            </button>
          </div>
        </div>
      </div>

      <FloatingSupportButtons />
      <SpinWheelNavButton 
        position="right"
        bottom="180px"
        right="30px"
        pulseEffect={true}
        size="60px"
      />
    </>
  );
};

export default Dashboard;